import { observer } from 'mobx-react-lite';
import { Stack, useTheme, useMediaQuery } from '@mui/material';

import { TLifeEventType } from '@/types/ProfileBuilder/profileBuilder';
import { Group } from '@/types/Content/Group';
import { useMemo } from 'react';
import { VisibilityInfo } from '../../hooks/useLifeEventVisibility';
import LifeEventGroups from './LifeEventGroups';

type GroupListProps = {
  subscriptionGroupList: Group[];
  visibilityInfo: VisibilityInfo;
  lifeEventsSorted: TLifeEventType[];
};

function GroupList({
  subscriptionGroupList,
  visibilityInfo,
  lifeEventsSorted,
}: GroupListProps): JSX.Element {
  const theme = useTheme();

  const matchesXl = useMediaQuery(theme.breakpoints.up('xl'));

  const groupedItems = useMemo(() => {
    if (!subscriptionGroupList?.length) return [];

    const grouped: Record<string, Group[]> = {};

    for (let i = 0; i < subscriptionGroupList.length; i++) {
      const item = subscriptionGroupList[i];
      item.lifeEventIds?.forEach((lifeEventId) => {
        grouped[lifeEventId] = grouped[lifeEventId] || [];
        grouped[lifeEventId].push(item);
      });
    }
    return grouped;
  }, [subscriptionGroupList]);

  if (!subscriptionGroupList?.length) return null;

  return (
    <Stack direction="column" spacing={theme.spacing(8)}>
      {lifeEventsSorted.map((lifeEvent) => {
        if (!groupedItems[lifeEvent.id]) return null;
        if (!(visibilityInfo[lifeEvent.id] ?? true)) return null;

        return (
          <LifeEventGroups
            key={lifeEvent.id}
            lifeEvent={lifeEvent}
            items={groupedItems[lifeEvent.id]}
            matchesXl={matchesXl}
          />
        );
      })}
    </Stack>
  );
}

export default observer(GroupList);
